import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Box, Button, Card, Flex, Spinner, Text } from "@radix-ui/themes";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { DragAndDropFileUpload } from "../../../components/inputs/FileUpload/DragAndDropFileUpload";
import { routes } from "../../../routes";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";

import templateFile from "../../../assets/templates/load_students_in_bulk.xlsx";
import readXlsxFile from "read-excel-file";
import { useState } from "react";
import ExcelPreviewTable from "./ExcelPreviewTable";
import { useMutation } from "react-query";
import { createUser } from "../../user/createUser";
import { createStudent, createStudentCode } from "./createStudent";
import { createEnrollment } from "./createEnrollment";
import { addUserRole } from "../../user/addUserRole";
import { UserType } from "../../../types/User";
import { staticRoles } from "../../../staticRoles";
import { useGetCoursesQuery } from "../../../hooks/useGetCoursesQuery";
import { createCoursePlan, getCoursePlans } from "../CoursePlans";
import { isEmpty, map, set } from "lodash";
import { createAcademicLevel } from "../academicLevel";
import { useGetCurrentAcademicYearQuery } from "../../../hooks/useGetCurrentAcademicYearQuery";
import { CoursePlanType } from "../../../types/CoursePlan";
import { createAcademicYear } from "../academicYear/createAcademicYear";
import { formatDateForInput, formatDateForOutput } from "../../../utils/dateFormatter";
import { GenerateCodeStudentType } from "../../../types/Student";
import { mapRegime } from "../../../utils/studentUtils";
import { useGetAcademicYearQuery } from "../../../hooks/useGetAcademicYearQuery";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
const AddStudentWithExcelFileValidation = yup.object().shape({
  file: yup
    .mixed<File>()
    .required("O ficheiro é obrigatório")
    .test("fileFormat", "Apenas ficheiros .xlsx são permitidos", (value) =>
      value instanceof File ? value.name.endsWith(".xlsx") : false
    ),
  year: yup.string().required("Campo é obrigatório"),
});

const schema = {
  'Nome': { prop: 'name', type: String, required: true },
  'Documento': { prop: 'document', type: String },
  'Género (M/F)': { prop: 'gender', type: String },
  'Data de Nascimento (YYYY-MM-DD)': { prop: 'birthDate', type: Date },
  'NUIT': { prop: 'nuit', type: String },
  'É Estrangeiro (S/N)': { prop: 'isForeign', type: String },
  'Curso': { prop: 'course', type: String },
  'Regime': { prop: 'regime', type: String },
  'Condições Especiais': { prop: 'specialConditions', type: String },
  'Possui Dispositivo Eletrônico': { prop: 'hasDevice', type: String },
  'Província': { prop: 'province', type: String },
  'Província onde concluiu 12ª classe': { prop: 'province12th', type: String },
  'Local onde concluiu 12ª classe': { prop: 'place12th', type: String },
  'País de Origem (se estrangeiro)': { prop: 'originCountry', type: String },
  'Ano de ingresso': { prop: 'entryYear', type: Number },
  'Ano de conclusão': { prop: 'conclusionYear', type: Number },
  'Provincia Matriculado': { prop: 'provinceEnrolled', type: String },
  'Novo ingresso(S/N)?': { prop: 'isNewEntry', type: String },
  'Cancelou Matricula?': { prop: 'cancelled', type: String },
  'Motivo de cancelamento': { prop: 'cancelReason', type: String },
};
export default function AddStudentWithExcel() {

  const { data: courses, isLoading: isLoadingCourses, isError: errorCourses, refetch: refreshCourses } = useGetCoursesQuery(
    { PageNumber: 1, PageSize: 400 },
  );
      const { data: academicYears, isLoading: isLoadingAcademicYears, isError: errorAcademicYears } = useGetAcademicYearQuery({ PageNumber: 1, PageSize: 400 });
  
  const [excelData, setExcelData] = useState<any[]>([]);
  const [validRows, setValidRows] = useState<any[]>([]);
  const mutationCreateUser = useMutation({ mutationFn: createUser, mutationKey: "createUser" })
  const mutationCreateStudentCode = useMutation({ mutationFn: createStudentCode, mutationKey: "createStudentCode" })
  const mutationCreateStudent = useMutation({ mutationFn: createStudent, mutationKey: "createStudent" })
  const mutationCreateEnrollment = useMutation({ mutationFn: createEnrollment, mutationKey: "createEnrollment" })
  const mutationAddUserRole = useMutation({ mutationKey: "addUserRole", mutationFn: addUserRole });
  const mutationCreateAcademicYear = useMutation({ mutationFn: createAcademicYear, mutationKey: "createAcademicYear" });
  const mutationCreateCoursePlan = useMutation({ mutationFn: (createCoursePlan), mutationKey: 'createUpdateCoursePlan' });
  
  const loadingState = mutationCreateUser.isLoading
    || mutationCreateStudentCode.isLoading
    || mutationCreateStudent.isLoading
    || mutationCreateEnrollment.isLoading
    || mutationAddUserRole.isLoading
    || mutationCreateAcademicYear.isLoading
    ;
    
  const {
    reset,
    control,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<{ file: File, year: string }>({
    resolver: yupResolver(AddStudentWithExcelFileValidation),
    mode: "onBlur",
    reValidateMode: "onBlur",
  });

  const onSubmit = handleSubmit(async (data) => {
    if (validRows.length === 0) {
      toast.error("Não há estudantes válidos para submissão.");
      return;
    }
    let idAcademicYear= data.year;
  
    for (const row of validRows) {
      try {
        const dateOfBirth = formatDateForInput((row?.birthDate as Date).toISOString());
        const userName = row.document || row.nuit || row.name;
        const bi = row.document;
        const userPayload = {
          name: row.name,
          userName: userName,
          bi: bi,
          gender: row.gender,
          dateOfBirth:dateOfBirth,
          nuit: row.nuit,
          isForeign: row.isForeign === "S",
          phoneNumber: "111111111",
          email:`${bi}@estudante.esura`, 
        };
        const userResult = await mutationCreateUser.mutateAsync(userPayload as UserType);
        const { id: idUser } = userResult as any
        if (!idUser) throw new Error("Erro ao criar o utilizador.");
        await mutationAddUserRole.mutateAsync({
          roleId: staticRoles.Student,
          userId: idUser,
        });
        const course = courses?.items.find((c) => c.code === row.course);
        if (!course) throw new Error(`Curso "${row.course}" não encontrado.`);
        if(!row?.entryYear || isNaN(row?.entryYear) || row?.entryYear < 1900 || row?.entryYear > new Date().getFullYear()) {
          throw new Error(`Ano de ingresso inválido para ${row.name}.`);
        }
        try {
          row.regime = mapRegime(row.regime);
        } catch (error) {
           throw new Error(`Regime não encontrado. Consulte a lista de regimes disponíveis.`);
        }
        const academicYear = academicYears?.items.find(ay => ay.id ==data.year);
        let syncAndGenerateCode:GenerateCodeStudentType = {
          bi,
          document:row.document,
          provinceEnrolled:row?.provinceEnrolled,
          idCourse: course.id,
          enrollmentYear:`${row?.entryYear}`,
          isGraduated: isEmpty(row?.conclusionYear),
          certificate: isEmpty(row?.conclusionYear)?null:"N/D",
          isCancel:row?.cancelled==="S",
          canceledReason:row?.cancelReason,
          code: course.code,
          courseName: course.name || course.description,
          nuit: userPayload.isForeign ? bi : row.nuit,
          year:`${academicYear?.year}`,
          idUser: idUser,
          idRegime: row.regime,
          name: row.name,
          gender: row.gender,
          dateOfBirth: dateOfBirth,
          isForeign: userPayload.isForeign,
          country: row.originCountry,
          specialConditions: row.specialConditions,
          eletronicDevice: row.hasDevice,
          province: row.province,
          provinceGraduated12OrEqual: row.province12th,
          localGraduated12OrEqual: row.place12th,
          courseLevel: course.level,
          modality: course.modality,
          isNewStudent: row.isNewEntry === "S",
        };
        if (syncAndGenerateCode?.isGraduated && row?.conclusionYear) {
          let dateValue: Date;

          if (typeof row.conclusionYear === "number" || /^\d{4}$/.test(row.conclusionYear.toString())) {
            dateValue = new Date(`${row.conclusionYear}-01-01`);
          } else {
            dateValue = new Date(row.conclusionYear);
          }

          syncAndGenerateCode.dateGraduated = formatDateForInput(dateValue.toISOString());
        }

        const studentCode = await mutationCreateStudentCode.mutateAsync(syncAndGenerateCode as GenerateCodeStudentType);
        if (!studentCode) throw new Error("Erro ao gerar o código do estudante.");
        const studentResult = await mutationCreateStudent.mutateAsync({
          idUser: idUser,
          studentUniversalCode: studentCode,
          schoolCode: studentCode,
          fullname: row.name,
          isForeign: userPayload.isForeign,
          countryDescription: row.originCountry,
          specialConditions: row.specialConditions,
          eletronicDevice: row.hasDevice,
          province: row.province,
          syncData: syncAndGenerateCode,
          enrollmentYear: `${row.entryYear}`,
          provinceGraduated12OrEqual: row.province12th,
          localGraduated12OrEqual: row.place12th,
        });
       if (!studentResult) throw new Error("Erro ao criar o estudante.");
       const coursePlans = await getCoursePlans({ IdCourse: course.id, IdAcademicYear: idAcademicYear });
      const coursePlan = coursePlans?.items.at(0);
       let coursePlanId = coursePlan?.id;
       if(!coursePlans || !coursePlans.items || coursePlans.items.length === 0) {
        const coursePlanToSave:CoursePlanType = {
          idCourse: course.id,
          idAcademicYear: idAcademicYear??"",
          docBase64: "",
          extension:".nt",
          idFaculty: course.idFaculty,
          idUniversity: course.idUniversity,
          idDepartament: course.idDepartament,
        }
        const createdCoursePlan = await mutationCreateCoursePlan.mutateAsync(coursePlanToSave);
        if (!createdCoursePlan) throw new Error("Erro ao criar o plano de curso.");
        coursePlanId = createdCoursePlan;
       }
       const enrollmentResult = await mutationCreateEnrollment.mutateAsync({
          idCourse: course.id,
          idAcademicYear: idAcademicYear,
          idStudent: studentResult,
          regime: row.regime,
          subscribeStudent: false,
          idPlan: coursePlanId,
        });
        if (!enrollmentResult) throw new Error("Erro ao matricular o estudante.");
        toast.success(`✅ ${row.name} matriculado com sucesso`);
        setExcelData((prev) => prev.filter((r) => r.document !== row.document));
        setValidRows((prev) => prev.filter((r) => r.document !== row.document));
      } catch (err: any) {
        toast.error(`Erro ao registar ${row.name}: ${err?.message}`);
        continue;
      }
    }
  });
  async function handleFileOnChange(file: File | null) {
    if (!file) {
      setExcelData([])
      setValidRows([])
      return;
    }
    const { rows, errors } = await readXlsxFile(file, { schema });
    if (errors.length > 0) {
      console.error("Erros na leitura do Excel:", errors);
      toast.error("Existem erros no ficheiro Excel. Verifique os campos.");
      return;
    }
    setExcelData(rows);
  }
  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size="1">
        <Flex direction="column" gap="4">
          <Box>
            <Text as="p" size="2" mb="2">
              Caso ainda não tenha o template,{" "}
              <a
                href={templateFile}
                download
                style={{ color: "blue", textDecoration: "underline" }}
              >
                📃
              </a>.
            </Text>
          </Box>
          <SelectComponent name='year' label='Ano acadêmico' control={control} errors={errors} style={{ width: '100%' }}
            options={academicYears?.items.map(ay => ({
              value: ay.id ?? '',
              label: ay.year ?? ''
            }))}
            itemsError={errorAcademicYears}
            itemsLoading={isLoadingAcademicYears}
            required={true}
          />
          <Box>
            <Text as="label" size="2"><span>Ficheiro dos estudantes <span style={{ color: 'red' }}>*</span></span></Text>
            <Controller
              name="file"
              control={control}
              render={({ field }) => (
                <DragAndDropFileUpload
                  onFileDrop={(file) => {
                    field.onChange(file);
                    handleFileOnChange(file);
                  }}
                  label="Arraste ou selecione o ficheiro"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  selectedFile={field.value}
                  required={true}
                />
              )}
            />

            {errors.file && (
              <Text color="red" size="1">{`${errors.file.message}`}</Text>
            )}
          </Box>

          <ExcelPreviewTable rawData={excelData} onValidRowsChange={setValidRows} />

          <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
            <Button type="submit" disabled={false} variant="surface">
              {false ? (
                <Spinner loading>
                  <EnterIcon />
                </Spinner>
              ) : (
                <EnterIcon />
              )}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}
